import { render, staticRenderFns } from "./TalkBranch.vue?vue&type=template&id=72376636&scoped=true&"
import script from "./TalkBranch.vue?vue&type=script&lang=ts&"
export * from "./TalkBranch.vue?vue&type=script&lang=ts&"
import style0 from "./TalkBranch.vue?vue&type=style&index=0&id=72376636&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72376636",
  null
  
)

export default component.exports